import { PluginKey } from 'prosemirror-state';
export var pluginKey = new PluginKey('helpDialogPlugin');
//# sourceMappingURL=plugin-key.js.map